import { createFileRoute } from '@tanstack/react-router';
import { TaxBindersListPage } from '@/features/preparer/tax-binders/TaxBindersListPage';
import { z } from 'zod';
import { userSettingQueryOptions } from '@/lib/query/options';

// Define search params schema for sticky filtering/sorting
const bindersSearchSchema = z
  .object({
    page: z.number().int().positive().optional().catch(undefined),
    rowsPerPage: z.number().int().positive().optional().catch(undefined),
    sortBy: z.string().optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    status: z.string().optional().catch(undefined),
    taxYear: z.string().optional().catch(undefined),
    stage: z.string().optional().catch(undefined),
    hasLateDocuments: z.string().optional().catch(undefined),
  })
  .passthrough(); // Allow unknown keys to pass through

export const Route = createFileRoute('/preparer/tax-binders/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient.prefetchQuery(userSettingQueryOptions.current(authState.token)).catch(() => {});
    }
  },
  component: TaxBindersListPage,
  validateSearch: bindersSearchSchema,
});
